export default {
  signin: {
    title: "Authorization",
    userForm: {
      username: {
        placeholder: "Username"
      },
      password: {
        placeholder: "Password"
      },
      language: {
        placeholder: "Language"
      },
      connection: {
        placeholder: "Connection"
      },
      server: {
        placeholder: "Server"
      },
      section: {
        placeholder: "Section"
      },
      base: {
        placeholder: "Base"
      },
      signin: "Sign in"
    },
    userRules: {
      username: {
        required: "Username is required",
        min: "Username should have more than 3 symbols",
        max: "Username should have less than 24 symbols"
      },
      password: {
        required: "Password is required",
        min: "Password should have more than 3 symbols",
        max: "Password should have less than 24 symbols"
      },
      language: {
        required: "Language is required"
      },
      connection: {
        required: "Connection is required"
      },
      server: {
        required: "Server is required"
      },
      section: {
        required: "Section is required"
      },
      base: {
        required: "Base is required"
      }
    },
    version: {
      current: "Version:",
      serverMin: "Server (min.):",
      apiMin: "API (min.):"
    }
  }
};
